import React from 'react';
import { Box, Card, CardContent, Chip, Typography, alpha, useTheme } from '@mui/material';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';

import PaymentCompletedDetails from './PaymentCompletedDetails';
import PaymentOptionSelections from './PaymentOptionSelections';

function ShipmentPayment() {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: '14px',
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 2px 8px -2px rgba(0, 0, 0, 0.03)',
        bgcolor: 'background.paper',
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          py: 2,
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 36,
              height: 36,
              borderRadius: '10px',
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: 'primary.main',
            }}
          >
            <PaymentOutlinedIcon sx={{ fontSize: '20px' }} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: 'primary.main',
                  letterSpacing: '-0.01em',
                }}
              >
                Payment Information
              </Typography>
              <Chip
                label="Billing"
                size="small"
                sx={{
                  height: 22,
                  fontSize: '12px',
                  fontWeight: 500,
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  color: 'primary.main',
                  borderRadius: '6px',
                }}
              />
            </Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'text.secondary', mt: 0.25 }}>
              Payment method, transaction records, and settlement status
            </Typography>
          </Box>
        </Box>
      </Box>

      <CardContent
        sx={{
          p: 3,
          '&:last-child': { pb: 3 },
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
          <PaymentOptionSelections />
          <PaymentCompletedDetails />
        </Box>
      </CardContent>
    </Card>
  );
}

export default ShipmentPayment;
